<template>
  <div class="steps-container justify-content-md-around" :class="{ 'mb-0': step === 4}">
    <i class="far fa-angle-left d-block d-md-none" :class="{ 'step-1': step == 1, 'mr-1': step > 1 }"></i>
    <div class="step" :class="{ 'step-active': step == 1, 'd-none': step != 1, 'd-md-block': step != 1 }">
      <span v-if="step > 1"><i class="far fa-check-circle"></i></span>
      <span class="step-count" v-else>1</span>
      <span>Your membership</span>
    </div>
    <i v-if="step == 1" class="far fa-angle-right d-block d-md-none"></i>
    <div class="step-dash d-none d-md-block"></div>
    <div class="step" :class="{ 'step-active': step == 2, 'd-none': step != 2, 'd-md-block': step != 2 }">
      <span v-if="step > 2"><i class="far fa-check-circle"></i></span>
      <span class="step-count" v-else>2</span>
      <span>Your donation</span>
    </div>
    <div class="step-dash d-none d-md-block"></div>
    <div class="step" :class="{ 'step-active': step == 3, 'd-none': step != 3, 'd-md-block': step != 3 }">
      <span v-if="step > 3"><i class="far fa-check-circle"></i></span>
      <span class="step-count" v-else>3</span>
      <span>Confirm your details</span>
    </div>
    <div class="step-dash d-none d-md-block"></div>
    <div class="step" :class="{ 'step-active': step == 4, 'd-none': step != 4, 'd-md-block': step != 4 }">
      <span v-if="step > 4"><i class="far fa-check-circle"></i></span>
      <span class="step-count" v-else>4</span>
      <span>Payment</span>
    </div>
    <i v-if="step > 1" class="far fa-angle-right d-block d-md-none"></i>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      step: state => state.renewal.step
    }),
  },
}
</script>
